import { createFileRoute } from "@tanstack/react-router";
import { LegalList, LegalPage, LegalSection } from "@/components/LegalPage";

export const Route = createFileRoute("/complaints")({
  component: ComplaintsPage,
});

function ComplaintsPage() {
  return (
    <LegalPage
      title="Complaints Policy"
      effective="CREDIKING FINANCIAL SERVICE LIMITED · Effective Date: 20th August, 2026"
    >
      <LegalSection title="1. Purpose">
        <p>
          Crediking Financial Service Limited is committed to treating all customers fairly,
          transparently, and professionally. This Policy sets out how we handle complaints in line
          with the CBN Consumer Protection Framework, Consumer Protection Regulations, and applicable
          FCCPC requirements. Our goal is a fair, timely, accessible, transparent, and independent
          complaints process that enhances customer confidence.
        </p>
      </LegalSection>

      <LegalSection title="2. Scope">
        <p>
          This Policy applies to all customers, prospective customers, and authorised representatives
          regarding our loan products, services, fees, collections, data handling, or any other aspect
          of our relationship.
        </p>
      </LegalSection>

      <LegalSection title="3. What is a Complaint?">
        <p>
          A complaint is any expression of dissatisfaction (oral or written) about our products,
          services, staff conduct, processes, or failure to meet expectations or regulatory standards.
        </p>
      </LegalSection>

      <LegalSection title="4. How to Lodge a Complaint">
        <p>We provide multiple free, accessible channels:</p>
        <LegalList
          items={[
            <>In-app / Website portal</>,
            <>Email: credikingltd@gmail.com</>,
            <>Phone / WhatsApp / Hotline: 09122290559</>,
            <>Physical / Postal Address: No 6 University Road, Yaba, Lagos</>,
          ]}
        />
        <p>When lodging a complaint, please provide:</p>
        <LegalList
          items={[
            <>Full name, contact details, and account/loan reference</>,
            <>Clear description of the issue, dates, and amounts involved</>,
            <>Supporting documents (statements, screenshots, correspondence)</>,
            <>Preferred resolution</>,
          ]}
        />
        <p>We do not require payment of any fee to lodge or process a complaint.</p>
      </LegalSection>

      <LegalSection title="5. Acknowledgement and Tracking">
        <LegalList
          items={[
            <>
              We acknowledge receipt of every complaint (including verbal ones after transcription)
              within 24 hours and issue a unique reference/tracking number.
            </>,
            <>You may use this number to follow up.</>,
          ]}
        />
      </LegalSection>

      <LegalSection title="6. Investigation and Resolution Timelines">
        <LegalList
          items={[
            <>We aim to resolve most complaints within 14 days (or 2 weeks) of receipt, in line with CBN guidance.</>,
            <>Complex matters (e.g. excess charges, loan-related disputes) may take up to 30 days.</>,
            <>We will keep you informed of progress and any need for additional information.</>,
            <>
              Final response will be in writing (email or letter), stating whether the complaint is
              upheld (in whole or part), reasons, and any redress offered (refund, apology,
              correction, compensation, etc.).
            </>,
          ]}
        />
      </LegalSection>

      <LegalSection title="7. Fairness and Independence">
        <p>
          Complaints are handled by trained staff with adequate resources. Where possible, the
          handling function operates with independence from the business unit involved. Decisions are
          based on facts, evidence, and applicable regulations.
        </p>
      </LegalSection>

      <LegalSection title="8. Escalation">
        <p>
          If you are not satisfied with our final response, or if we fail to acknowledge within the
          required time or resolve within the stipulated timeline, you retain the right to pursue
          other legal or alternative dispute resolution options.
        </p>
      </LegalSection>

      <LegalSection title="9. Continuous Improvement">
        <p>
          We record, analyse, and report complaints (including to regulators as required). Insights
          are used to improve products, processes, and staff training. We publish summary statistics
          periodically where required.
        </p>
      </LegalSection>

      <LegalSection title="10. Contact for this Policy">
        <p>
          The contacts for this policy are as listed above. This Policy is available on our website
          and upon request. It may be updated to reflect regulatory changes; the current version will
          always be posted online.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
